import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty, replace } from 'lodash';

@Pipe({
  name: 'wysiwyg',
  standalone: true
})
export class WYSIWYGPipe implements PipeTransform {
  transform(WYSIWYGText: string): string {
    if (isEmpty(WYSIWYGText)) {
      return WYSIWYGText;
    }

    let normalizedWYSIWYGText = WYSIWYGText;

    normalizedWYSIWYGText = replace(normalizedWYSIWYGText, /(?<=\w)&nbsp;(?=\w)/g, ' ');

    return normalizedWYSIWYGText;
  }
}
